import { encodeURL } from './utils';

export default class EventManager {
  constructor(CropDusterInstance, environment) {
    this.CD = CropDusterInstance;
    this.appKey = this.CD.params('mi_app_key') || this.CD.params('app_key');
    this.environment = environment;
  }

  send(event, params = {}) {
    const eventURL = this.getURLForEvent(event, params);

    if (!eventURL) {
      return;
    }

    if (typeof fetch !== 'undefined') {
      // keep-alive: true will continue request even if we navigate away
      // from the page
      fetch(eventURL, { method: 'get', mode: 'no-cors', 'keep-alive': true });
    } else {
      const image = new Image(1, 1);
      image.src = eventURL;
    }
  }

  getURLForEvent(event, params) {
    if (this.environment === 'development') {
      console.log(`Would fire ${event} event`);
      //return;
    }

    try {
      const { appKey } = this;
      if (typeof appKey !== 'undefined' && appKey.length) {
        console.log(`Firing ${event} event`);
        const miU = this.CD.params('mi_u') || '';
        return encodeURL(
          `https://ar.micpn.com/p/lp/${appKey}/t`,
          Object.assign(params, {
            event_type: event,
            mi_u: miU
          })
        );
      }
    } catch (e) {
      console.error(`Failed to send event ${event}`);
    }
  }

  setupEngagementEvents() {
    this.send('pageview');
    [10, 30, 60].forEach(t => {
      setTimeout(() => {
        this.send(`engage_${t}s`);
      }, t * 1000);
    });
  }
}
